fragment flexibleTypeformEmbed on flexibleSections_typeformEmbed_BlockType {
    entryLinkExternal {
        ... on externalLinks_default_Entry {
            externalUrl
        }
    }
}
